import axios from 'axios';
import { serialize } from 'object-to-formdata';

export default (data, params) =>
  axios.post(`/v1/announcements`, serialize(data), { params }).then(({ data }) => data);
